<template>
    <el-table
        ref="eleTable"
        :data="tableData"
        :stripe="stripe"
        :border="border"
        :size="size"
        :header-cell-style="cellStyle"
        v-loading="loadingData"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
        @sort-change="handSortChange"
        :max-height="maxHeight"
        :highlight-current-row="highlight"
        @cell-click="handCellClick"
        :row-key="rowKey"
    >
        <el-table-column type="selection" width="42" v-if="selectShow" :reserve-selection="true" fixed="left"></el-table-column>
        <el-table-column
            v-for="(item,i) in dataFront"
            :key="i"
            :align="item.align ? item.align : align"
            :header-align="item.headerAlign ? item.headerAlign : item.align"
            :resizable="resizable"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :show-overflow-tooltip="item.overflow ? true : false"
            :fixed="item.fixed ? item.fixed : false"
        >
            <template slot-scope="scope">
                <el-slot v-if="item.render" :render="item.render" :row="scope.row" :index="scope.$index" :column="item"/>
                <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
let elSlot = {
    functional: true,
    props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
            type: Object,
            default: null
        }
    },
    render: (h, data) => {
        const params = {
            row: data.props.row,
            index: data.props.index
        }
        if (data.props.column) params.column = data.props.column
        return data.props.render(h, params)
    }
}
export default {
    props: {
        tableData: Array, //表格数据
        dataFront: Array, //表头显示
        loadingData:{  //加载显示
            type: Boolean,
            default: false
        },
        selectShow: { //是否显示勾选
            type: Boolean,
            default: false
        },
        cellStyle: {
            type: Object,
            default(){
                return { background: '#EFF4FF', color: '#999' }
            }
        },
        highlight: { //是否高亮当前行
            type: Boolean,
            default: false
        },
        border: { //是否显示边框
            type: Boolean,
            default: false
        },
        size: { //表格大小
            type: String,
            default: 'small'
        },
        stripe: { //是否显示斑马线
            type: Boolean,
            default: false
        },
        align: {  // 文本对齐方式
            type: String,
            default: 'left'
        },
        resizable: { //是否可以通过拖动改变宽度
            type: Boolean,
            default: false
        },
        maxHeight: { //是否设置最大高度
            type: Number,
            default: null
        },
        rowKey: {
            type: String,
            default: ''
        }
    },
    components: { 
        elSlot
    },
    data() {
        return {
        };
    },
    methods:{
        //勾选
        handleSelectionChange(val) {
            this.$emit("batchchoice", val);
        },
        //排序
        handSortChange({order,prop}){
            this.$emit("sortChange", {order,prop});
        },
        //某个单元格被点击时会触发该事件
        handCellClick(row, column, event){
            if(this.highlight){
                this.$emit("handleCurrentChange", row)
            }
        },
        //清除排序方式
        handleClearSort(){
            this.$refs.eleTable.clearSort()
        },
        //重置勾选
        clearSelection(){
            this.$refs.eleTable.clearSelection()
        }
    }
}
</script>